export default "__VITE_ASSET__a6lAKqXD__"